import { ReactNode } from 'react';
import { Button } from "@/shared/ui/button";

/**
 * Props para o componente FormFooter
 */
export interface FormFooterProps {
    /** Classes CSS adicionais */
    className?: string;
    
    /** Botões customizados */
    children: ReactNode;
    
    /** Função de cancelamento */
    onCancel?: () => void;
    
    /** Estado de carregamento */
    isLoading?: boolean;
    
    /** Estado de sucesso */
    isSuccess?: boolean;
    
    /** Texto do botão de cancelar */
    cancelButtonText?: string;
}

/**
 * Componente de rodapé de formulário simplificado
 * 
 * @description
 * Este componente fornece um container simples para botões de ação de formulário.
 * A lógica de validação, estados e comportamento ficam por conta do componente pai.
 * 
 * @example
 * ```tsx
 * <FormFooter>
 *   <Button variant="outline" onClick={onCancel}>
 *     Cancelar
 *   </Button>
 *   <Button onClick={handleSave} disabled={isLoading}>
 *     {isLoading ? 'Salvando...' : 'Salvar'}
 *   </Button>
 * </FormFooter>
 * ```
 * 
 * @param props - Props do componente
 * @returns JSX.Element
 */
export const FormFooter = ({ 
    className = "",
    children,
    onCancel,
    isLoading = false,
    isSuccess = false,
    cancelButtonText = "Cancelar"
}: FormFooterProps) => {

    return (
        <div className={`flex justify-end gap-4 ${className}`}>
            {onCancel && (
                <Button
                    type="button"
                    variant="outline"
                    onClick={onCancel}
                    className="bg-transparent border-[#333333] text-white hover:bg-[#222222] hover:text-white/60"
                    disabled={isLoading}
                >
                    {cancelButtonText}
                </Button>
            )}
            {children}
        </div>
    );
};